export default __webpack_public_path__ + "static/AmbientStudiosLogoWhite-126ea4e7cce4ea95cc5f82bc30c92cd6.png";